import {SummaryModel} from '../../summary.model';
import {PlainDtoModel} from './plainDto.model';
import {PermissionsModel} from '../../permissions.model';

export abstract class WithSummaryModel<S extends SummaryModel> implements PlainDtoModel {
    summary: S;
}
